import { DropdownProps, DropdownState, ToggleDropdown } from './Dropdown.types'
import { useCallback, useEffect, useRef, useState } from 'react'

export function useDropdownState(props: DropdownProps): DropdownState {
  const { disabled, buttonId, menuId } = props
  const [dropdownAnchorElement, setDropdownAnchorElement] = useState<HTMLElement | null>(null)
  const isOpen = Boolean(dropdownAnchorElement)
  const [hasOpened, setHasOpened] = useState(false)
  useEffect(() => {
    if (isOpen) {
      setHasOpened(true)
    }
  }, [isOpen, hasOpened, setHasOpened])
  const toggleDropdown = useCallback<ToggleDropdown>(
    el => {
      if (isOpen) {
        setDropdownAnchorElement(null)
      } else if (!disabled) {
        setDropdownAnchorElement(el)
      }
    },
    [disabled, isOpen, setDropdownAnchorElement]
  )
  const closeDropdown = useCallback(() => {
    setDropdownAnchorElement(null)
  }, [setDropdownAnchorElement])

  const buttonRef = useRef<HTMLButtonElement>(null)
  useEffect(() => {
    if (!isOpen && hasOpened && buttonRef.current) {
      buttonRef.current.focus()
    }
  }, [hasOpened, isOpen, buttonRef])

  return {
    menuId,
    buttonId,
    hasOpened,
    disabled: disabled ?? false,
    isOpen,
    toggleDropdown,
    closeDropdown,
    dropdownAnchorElement,
    buttonRef
  }
}
